// tslint:disable: max-line-length
import { ElementRef, InjectFlags, Injectable, Optional, Self } from '@angular/core';
import { Repository, Entity, FrameContext, PARENT_CLASS, ChangeType, ValidationResult, ValidationError, ValidateRule, ViewModel, DataTypeInfo, DataPropGroup, DataPropInfo, BindingList, ComponentType } from '@farris/devkit';
import { tap, switchMap } from 'rxjs/operators';
import { EMPTY, Observable, Subject } from 'rxjs';
import { zip } from 'rxjs/observable/zip';
import { empty } from 'rxjs/observable/empty';
import { of } from 'rxjs/observable/of';
import { VerifyDetailService } from '@farris/ui-verify-detail';
import { FormNotifyService } from './form-notify.service';
import { LanguageService } from './languag.service';
import { VerifyService } from './verify.service';
import { DatagridComponent } from '@farris/ui-datagrid';

/**
 * è¡¨åéªè¯æå¡
 * @scope FrameComponent
 */

@Injectable()
class ValidationService {

  private validationResults = new Subject<any>();
  private validationAllResult = new Subject<any>();
  /**
   * æé å½æ°
   */
  constructor(
    private repository: Repository<any>,
    private frameContext: FrameContext,
    @Optional() private notifyService: FormNotifyService,
    @Optional() private languageService: LanguageService
  ) {
    if (!this.languageService) {
      this.languageService = new LanguageService();
    }
  }

  /**
   * éªè¯è¡¨ååçææè¡¨å
   */
  public validate() {
    this.repository.getList().subscribe(
      (result: Entity[]) => {
        for (const entity of result) {
          entity.validate().subscribe((result: ValidationResult) => {
            if (!result.isValid) {
              alert(result.message);
              this.validationResults.next(result);
            }
          });
        }
      }
    );
    return this.validationResults;
  }
  /**
   * æ ¡éªå½åè¡
   */
  public validateCurrentRow(): Observable<any> {
    const entityTypeInfo = this.repository.entityTypeInfo;
    // ç»åè¡¨ååªæ ¡éªå½åæé®æå¨çè¡¨å
    const primaryValue = this.frameContext.bindingData.list.currentId;
    if (!primaryValue) {
      return of(true);
    }
    // é¦åæ ¡éªå®ä½ä¸è½ä¸ºç©ºè§å
    const entity = this.repository.entityCollection.getEntityById(primaryValue);
    if (!entity) {
      return of(true);
    }

    const entities: Entity[] = [entity];
    const namespace = this.frameContext.namespace;
    let frameContexts = [];
    // ä¿®å¤ä½¿ç¨ç¸åbeåå»ºçvoçç»åè¡¨åæ ¡éªæ¶å¤ä¸ªè¡¨åæ ¡éªè§åè¢«åå¹¶çé®é¢
    // TODO: ç®åæªèèç»åè¡¨åç»ä¸ä¿å­çåºæ¯ï¼åç»­æ¯æç»åè¡¨åç»ä¸ä¿å­æ¶åä¿®æ¹
    if (namespace !== null) {
      // å­å¨å½åç©ºé´ï¼è¯´æè¡¨åè¾æ°ï¼å¯ä»¥ä¾èµè¯¥ç¹æ§
      frameContexts = this.frameContext.appContext.frameContextManager.getFrameContextsByNamespace(namespace);
    } else {
      // è¡¨åè¾èï¼è·åææçä¸ä¸æï¼å¨æ ¡éªé¶æ®µè¿æ»¤è§å
      frameContexts = this.frameContext.appContext.frameContextManager.getFrameContexts();
    }

    const isModal = this.isInDialog();
    const hasOwnVerifyDetailService = this.hasOwnVerifyDetailService();
    let rootViewModel = this.frameContext.root.viewModel;
    if (isModal && hasOwnVerifyDetailService) {
      rootViewModel = this.frameContext.getVirtualRootFrameContext().viewModel;
    }

    let toValidate = false;
    const formErrors = [];
    frameContexts.forEach((frameContext: FrameContext) => {
      if (frameContext.form && frameContext.form.enableValidate) {
        toValidate = true;
      }
    });
    if (!toValidate || entities.length < 1) {
      return of(true);
    }
    rootViewModel.verifyInformations = [];
    let formValid = true;
    let entityValid = true;
    const formValidationRules = new Map<string, ValidateRule[]>();
    frameContexts.forEach((formContext: FrameContext) => {
      const bindingObject = formContext.bindingData.getObject();
      // éç¥ææbindingData,
      bindingObject && bindingObject.setShowValidationMsg(true);
      if (formContext.form && formContext.form.enableValidate) {
        // è·åå½åè¡¨åä¸çææéªè¯è§å
        const currentFormValidationRules = formContext.form.getValidationRules();
        currentFormValidationRules.forEach((rules, path) => {
          if (formValidationRules.has(path)) {
            rules.forEach(rule => formValidationRules.get(path).push(rule));
          } else {
            formValidationRules.set(path, [...rules]);
          }
        });
        formContext.form.setShowValidationMsg(true);
        // éä¸ªè°ç¨è¡¨åçéªè¯ï¼éªè¯åç«¯è¡¨åè§å
        if (!formContext.form.isFormValid()) {
          formErrors.push(formContext.form);
          formValid = false;
        }
      }
    });

    // éªè¯ææå®ä½
    const observableList = entities.map((entity: Entity) => {
      const index = this.frameContext.bindingData.list.getIndexById(entity.primaryValue);
      return entity.validate(undefined, undefined, formValidationRules, null, this.frameContext);
    });
    const result$ = zip(...observableList).pipe(
      tap((resultList) => {
        frameContexts.forEach((formContext: FrameContext) => {
          if (!formContext.form.enableValidate) {
            return;
          }
          const handleErrors = (errors: ValidationError[]) => {
            errors.forEach((validationError: ValidationError) => {
              if (validationError.children && validationError.children.length) {
                handleErrors(validationError.children);
              }
              const errMsgObj = {};
              let id = '';
              const findId = (target: any) => {
                if (target && target.data && target.data.id) {
                  id = target.data.id;
                  return;
                } else if (target[PARENT_CLASS]) {
                  findId(target[PARENT_CLASS]);
                }
              };
              findId(validationError.target);

              // å®ä½éªè¯åºéï¼éè¦å°éè¯¯å±ç¤ºå°çé¢ä¸
              // å®ä½ä¸ä¸å®æ¯å½åè¡
              let parentPathData = {
                path: [],
                isUdt: false,
                isGrid: false
              };
              if (validationError.target) {
                parentPathData = validationError.target.getPaths();
              }
              const bindingPath = '/' + parentPathData.path.join('/');
              if (validationError.constraints) {
                Object.keys(validationError.constraints).forEach(key => {
                  errMsgObj[key] = {
                    name: validationError.constraints[key]
                  };
                  // if (this.frameContext.viewModel.bindingPath === bindingPath) {
                  //   rootViewModel['verifyInformations'].push({
                  //     id: id,
                  //     title: key,
                  //     msg: validationError.constraints[key],
                  //     type: 'warn'
                  //   })
                  // }
                });
              }
              const paths = parentPathData.path.concat(validationError.property);

              //if (this.frameContext.viewModel.bindingPath === bindingPath) {
              // å°éè¯¯ä¿¡æ¯æ´æ°å°formControlä¸
              formContext.bindingData.changes.next({
                type: ChangeType.UpdateErrors,
                id,
                path: paths,
                isUdt: parentPathData.isUdt,
                isGrid: parentPathData.isGrid,
                value: validationError.value,
                errors: errMsgObj
              });
              //}
            });
          };
          // å±å¼éªè¯ç»æ
          const isValidList = resultList.map((result: ValidationResult) => result.isValid);
          // ä¿å­ååè°ç¨å®ä½ä¸çéªè¯è§åï¼å¨é¨éè¿ä¹åæä¿å­
          // å®ä½éªè¯éè¿
          if (isValidList.filter(x => x).length === observableList.length) {
            // å°éè¯¯ä¿¡æ¯æ´æ°å°formControlä¸
            formContext.bindingData.changes.next({
              type: ChangeType.UpdateErrors,
              path: []
            });
            // éªè¯æååéèè¾å¥æ¶çéªè¯
            if (formValid) {
              const bindingObject = formContext.bindingData.getObject();
              bindingObject && bindingObject.setShowValidationMsg(false);
              const form = formContext.form;
              if (form) {
                form.setShowValidationMsg(false);
              }
            }
          } else {
            // å®ä½éªè¯æéè¯¯
            entityValid = false;
            resultList.forEach((result: ValidationResult) => {
              if (result.isValid) {
                // æ¸é¤éªè¯éè¿çéè¯¯
                formContext.bindingData.changes.next({
                  type: ChangeType.UpdateErrors,
                  path: []
                });
              } else {
                handleErrors(result.errors);
              }
            });
          }
        });
      }),
      switchMap((resultList) => {
        let isValidated = true;
        const errors = [];
        resultList.forEach((result: ValidationResult) => {
          if (!result.isValid) {
            isValidated = false;
          }
          errors.push(...result.errors);
        });
        if (errors.length > 0) {
          this.collectValidationErrors(rootViewModel, errors, this.frameContext.namespace);
        }
        // rootViewModel.verifycationChanged.next(rootViewModel.verifyInformations);
        let verifyInformations = rootViewModel.verifyInformations;
        if (isModal && hasOwnVerifyDetailService) {
          verifyInformations = rootViewModel.verifyInformations.filter(item => item.namespace === namespace);
        }
        rootViewModel.verifycationChanged.next(verifyInformations);
        this.handleErrorClickEvent();
        if (isValidated && !formValid) {
          // å®ä½æ ¡éªéè¿ä½è¡¨åæ ¡éªä¸éè¿ï¼æ­¤æ¶å®ä½åè¡¨åå­å¨æ ¡éªè§åä¸ä¸è´çæåµ
          console.warn('å®ä½åæ§ä»¶æ ¡éªè§åä¸ä¸è´ï¼è¯·ç¡®è®¤å®ä½æ ¡éªè§åéç½®ä¸æ§ä»¶ä¸è´ãå¦æéç½®ä¸ä¸è´å¯è½ä¼å¯¼è´æ ¡éªå¤±æï¼');
        }
        // å®ä½æ ¡éªéè¿ï¼å®ä½æ ¡éªä½¿ç¨çè§åæ¯æ§ä»¶+å®ä½ï¼æ­£å¸¸å®ä½æ ¡éªéè¿åæ§ä»¶æ ¡éªä¸å®ä¹ä¼éè¿
        if (isValidated) {
          const isEntityValid = this.validateEntityAllowEmptyRule(entityTypeInfo);
          if (!isEntityValid) {
            return EMPTY;
          }
          return of(true);
        } else {
          return empty();
        }
      })
    );
    return result$;
  }
  /**
   * è°ç¨è¡¨ååå®ä½ä¸çéªè¯è§å, éè¿åè°ç¨åè°cb
   */
  validateAll(): Observable<any> {
    const entityTypeInfo = this.repository.entityTypeInfo;
    // ç»åè¡¨ååªæ ¡éªå½åæé®æå¨çè¡¨å
    const entities: Entity[] = this.repository.entityCollection.getAllEntities();
    const namespace = this.frameContext.namespace;
    let frameContexts = [];
    if (namespace !== null) {
      // å­å¨å½åç©ºé´ï¼è¯´æè¡¨åè¾æ°ï¼å¯ä»¥ä¾èµè¯¥ç¹æ§
      frameContexts = this.frameContext.appContext.frameContextManager.getFrameContextsByNamespace(namespace);
    } else {
      // è¡¨åè¾èï¼è·åææçä¸ä¸æï¼å¨æ ¡éªé¶æ®µè¿æ»¤è§å
      frameContexts = this.frameContext.appContext.frameContextManager.getFrameContexts();
    }

    let toValidate = false;
    const formErrors = [];
    frameContexts.forEach((frameContext: FrameContext) => {
      if (frameContext.form && frameContext.form.enableValidate) {
        toValidate = true;
      }
    });
    if (!toValidate || entities.length < 1) {
      return of(true);
    }
    const isModal = this.isInDialog();
    const hasOwnVerifyDetailService = this.hasOwnVerifyDetailService();
    let rootViewModel = this.frameContext.root.viewModel;
    if (isModal && hasOwnVerifyDetailService) {
      rootViewModel = this.frameContext.getVirtualRootFrameContext().viewModel;
    }

    let formValid = true;
    let entityValid = true;
    const formValidationRules = new Map<string, ValidateRule[]>();
    frameContexts.forEach((formContext: FrameContext) => {
      const bindingObject = formContext.bindingData.getObject();
      // éç¥ææbindingData,
      bindingObject && bindingObject.setShowValidationMsg(true);
      if (formContext.form && formContext.form.enableValidate) {
        // è·åå½åè¡¨åä¸çææéªè¯è§å
        const currentFormValidationRules = formContext.form.getValidationRules();
        currentFormValidationRules.forEach((rules, path) => {
          if (formValidationRules.has(path)) {
            rules.forEach(rule => formValidationRules.get(path).push(rule));
          } else {
            formValidationRules.set(path, [...rules]);
          }
        });
        formContext.form.setShowValidationMsg(true);
        // éä¸ªè°ç¨è¡¨åçéªè¯ï¼éªè¯åç«¯è¡¨åè§å
        if (!formContext.form.isFormValid()) {
          formErrors.push(formContext.form);
          formValid = false;
        }
      }
    });
    // è§¦åææå®ä½çvalidateäºä»¶
    const isMultiEntityValiate = entities.length > 0;

    // éªè¯ææå®ä½
    const observableList = entities.map((entity: Entity, index: number) =>
      entity.validate(undefined, undefined, formValidationRules, isMultiEntityValiate ? index : null, this.frameContext));
    const result$ = zip(...observableList).pipe(
      tap((resultList) => {
        frameContexts.forEach((formContext: FrameContext) => {
          if (!formContext.form.enableValidate) {
            return;
          }
          const handleErrors = (errors: ValidationError[]) => {
            errors.forEach((validationError: ValidationError) => {
              if (validationError.children && validationError.children.length) {
                handleErrors(validationError.children);
              }
              const errMsgObj = {};
              let id = '';
              const findId = (target: any) => {
                if (target && target.data && target.data.id) {
                  id = target.data.id;
                  return;
                } else if (target[PARENT_CLASS]) {
                  findId(target[PARENT_CLASS]);
                }
              };
              findId(validationError.target);

              // å®ä½éªè¯åºéï¼éè¦å°éè¯¯å±ç¤ºå°çé¢ä¸
              // å®ä½ä¸ä¸å®æ¯å½åè¡
              let parentPathData = {
                path: [],
                isUdt: false,
                isGrid: false
              };
              if (validationError.target) {
                parentPathData = validationError.target.getPaths();
              }
              const bindingPath = '/' + parentPathData.path.join('/');
              if (validationError.constraints) {
                Object.keys(validationError.constraints).forEach(key => {
                  errMsgObj[key] = {
                    name: validationError.constraints[key]
                  };
                  // if (this.frameContext.viewModel.bindingPath === bindingPath) {
                  //   rootViewModel['verifyInformations'].push({
                  //     id: id,
                  //     title: key,
                  //     msg: validationError.constraints[key],
                  //     type: 'warn'
                  //   })
                  // }
                });
              }
              const paths = parentPathData.path.concat(validationError.property);

              //if (this.frameContext.viewModel.bindingPath === bindingPath) {
              // å°éè¯¯ä¿¡æ¯æ´æ°å°formControlä¸
              formContext.bindingData.changes.next({
                type: ChangeType.UpdateErrors,
                id,
                path: paths,
                isUdt: parentPathData.isUdt,
                isGrid: parentPathData.isGrid,
                value: validationError.value,
                errors: errMsgObj
              });
              //}
            });
          };
          // å±å¼éªè¯ç»æ
          const isValidList = resultList.map((result: ValidationResult) => result.isValid);
          // ä¿å­ååè°ç¨å®ä½ä¸çéªè¯è§åï¼å¨é¨éè¿ä¹åæä¿å­
          // å®ä½éªè¯éè¿
          if (isValidList.filter(x => x).length === observableList.length) {
            // å°éè¯¯ä¿¡æ¯æ´æ°å°formControlä¸
            formContext.bindingData.changes.next({
              type: ChangeType.UpdateErrors,
              path: []
            });
            // éªè¯æååéèè¾å¥æ¶çéªè¯
            if (formValid) {
              const bindingObject = formContext.bindingData.getObject();
              bindingObject && bindingObject.setShowValidationMsg(false);
              const form = formContext.form;
              if (form) {
                form.setShowValidationMsg(false);
              }
            }
          } else {
            // å®ä½éªè¯æéè¯¯
            entityValid = false;
            resultList.forEach((result: ValidationResult) => {
              if (result.isValid) {
                // æ¸é¤éªè¯éè¿çéè¯¯
                formContext.bindingData.changes.next({
                  type: ChangeType.UpdateErrors,
                  path: []
                });
              } else {
                handleErrors(result.errors);
              }
            });
          }
        });
      }),
      switchMap((resultList) => {
        let isValidated = true;
        const errors = [];
        resultList.forEach((result: ValidationResult) => {
          if (!result.isValid) {
            isValidated = false;
            this.updateValidationErrors(result.errors);
            errors.push(...result.errors);
          }
          this.sortValidationErrors(errors);
        });
        if (errors.length > 0) {
          this.collectValidationErrors(rootViewModel, errors, this.frameContext.namespace);
        }
        let verifyInformations = rootViewModel.verifyInformations;
        if (isModal && hasOwnVerifyDetailService) {
          verifyInformations = rootViewModel.verifyInformations.filter(item => item.namespace === namespace);
        }
        // å ä¸ºæ ¡éªç´¯å çç¼æï¼å¯¼è´ä¹åçæ ¡éªä¿¡æ¯ä¸ç´å­å¨ï¼åªè½éè¿æ ¡éªç»ææ¥ç¡®å®æ¯å¦è¿æéè¯¯ä¿¡æ¯
        if (isValidated && formValid) {
          verifyInformations = rootViewModel.verifyInformations = [];
        }
        rootViewModel.verifycationChanged.next(verifyInformations);
        this.handleErrorClickEvent();
        if (isValidated) {
          const isEntityValid = this.validateEntityAllowEmptyRule(entityTypeInfo);
          if (!isEntityValid) {
            return EMPTY;
          }
          return of(true);
        } else {
          return empty();
        }
      })
    );
    return result$;
  }
  private updateValidationErrors(validationErrors: ValidationError[]) {
    validationErrors.forEach((validationError: ValidationError) => {
      if (validationError.children && validationError.children.length) {
        this.updateValidationErrors(validationError.children);
      }
      this.updateValidationError(validationError);
    });
  }
  private updateValidationError(validationError: ValidationError) {
    const target = validationError.target as Entity;
    const frameContext = validationError.frameContext;
    const bindingList = frameContext.bindingData.getList() as BindingList;
    if (frameContext && target && bindingList) {
      const index = bindingList.getIndexById(target.primaryValue);
      validationError.index = index;
      validationError.propertyName = validationError.buildDisplayName ? validationError.buildDisplayName(index) : validationError.propertyName;
    }
  }
  private sortValidationErrors(validationErrors: ValidationError[]) {
    validationErrors.forEach((validationError: ValidationError) => {
      if (validationError.children && validationError.children.length) {
        validationError.children.sort((current, next) => current.index - next.index);
      }
    });
    validationErrors.sort((current, next) => current.index - next.index);
  }
  /**
   * æ ¡éªå®ä½æ¯å¦æ»¡è¶³ä¸è½ä¸ºç©ºçè§å
   * @param entity ä¸»å®ä½
   */
  private validateEntityAllowEmptyRule(entityTypeInfo: DataTypeInfo) {
    // ç¡®è®¤å®ä½åä¸ªå±çº§ä¸­æ¯å¦å­å¨ä¸è½ä¸ºç©ºçè§å
    const paths = this.getNotAllowEmptyBindingPaths(entityTypeInfo);
    if (!paths || paths.length < 1) {
      return true;
    }
    // æ¾å°ææä¸åæ³çbindingPaths
    const invalidPaths = paths.filter((path: string) => {
      const bindingPaths = path.split('/').filter(p => p);
      const bindingList = this.frameContext.bindingData.getValue(bindingPaths) as BindingList;
      if (!bindingList || bindingList.length < 1) {
        return true;
      }
      return false;
    });
    // æå®ä½å¿å¡«ï¼ä½å®ä½æ°æ®ä¸ºç©º
    if (invalidPaths.length > 0) {
      const tableNames = [];
      invalidPaths.forEach((path: string) => {
        //const frameContexts = this.getFrameContextByBindingPath(path.split('/'));
        //const frameComponents = frameContexts.map(frameContext => frameContext.frameComponent);
        // æ¾å°ææå®¹å¨ç±»ç»ä»¶
        //const containerComponents = frameComponents.filter(frameComponent => [ComponentType.farrisDataGridComponent, ComponentType.farrisTreeTalbeComponent, ComponentType.kendoGridComponent, ComponentType.primengTreeComponent].includes(frameComponent.componentType));
        //if (!(!containerComponents || containerComponents.length < 1)) {
        const viewModelName = this.getViewModelNameByBindingPaths(path.split('/')) || `ç»å®è·¯å¾${path}`;
        tableNames.push(viewModelName);
        //}
      });
      if (this.notifyService) {
        this.notifyService.error(`${tableNames.join('ï¼')} ${this.languageService.tableCanNotEmpty}`, { hideTitle: true });
      }
      return false;
    }
    return true;
  }
  /**
   *
   * @param bindingPaths pathä¸è½ä¸ºç©ºæ/ï¼ä¸æ¯æä¸»è¡¨
   */
  private getViewModelNameByBindingPaths(bindingPaths: string[]) {
    const namespace = this.frameContext.namespace;
    let frameContexts: FrameContext[] = null;
    if (namespace !== null) {
      // å­å¨å½åç©ºé´ï¼è¯´æè¡¨åè¾æ°ï¼å¯ä»¥ä¾èµè¯¥ç¹æ§
      frameContexts = this.frameContext.appContext.frameContextManager.getFrameContextsByNamespace(namespace);
    } else {
      // è¡¨åè¾èï¼è·åææçä¸ä¸æï¼å¨æ ¡éªé¶æ®µè¿æ»¤è§å
      frameContexts = this.frameContext.appContext.frameContextManager.getFrameContexts();
    }
    const bindingPath = bindingPaths.filter(p => p).join('/');
    const frameContext = frameContexts.find((frameContext: FrameContext) => frameContext.viewModel && frameContext.viewModel.bindingPath.split('/').filter(p => p).join('/') === bindingPath);
    const viewModelName = frameContext && frameContext.form && frameContext.form.formGroupName || '';
    return viewModelName;
  }
  /**
   * éåè·åææä¸è½ä¸ºç©ºçå®ä½çç»å®è·¯å¾
   * @param entityTypeInfo
   * @param results
   * @returns
   */
  private getNotAllowEmptyBindingPaths(entityTypeInfo: DataTypeInfo, results: string[] = []): string[] {
    if (!entityTypeInfo) {
      return;
    }
    this.deepFirstTraversalEntityTypeInfo(entityTypeInfo, results);
    return results;
  }
  private deepFirstTraversalEntityTypeInfo(entityTypeInfo: DataTypeInfo, result: string[] = [], previousValue: string[] = []) {
    // ç¡®è®¤å½åå®ä½æ¯å¦å¿å¡«
    const isAllowEmpty = this.isAllowEmpty(entityTypeInfo.entityInfo.allowEmpty, previousValue);
    if (isAllowEmpty === false) {
      if (previousValue.length < 1) {
        result.push('');
      } else {
        result.push(previousValue.join('/'));
      }
    }
    // è·åææå­è¡¨
    const list = entityTypeInfo.getPropInfosByGroup(DataPropGroup.List);
    if (list && list.length > 0) {
      list.forEach((propInfo: DataPropInfo) => {
        const typeInfo = propInfo.typeInfo;
        if (typeInfo && typeInfo.entityInfo) {
          previousValue.push(typeInfo.entityInfo.nodeCode);
          this.deepFirstTraversalEntityTypeInfo(typeInfo, result, previousValue);
        }
      });
    }
    // æ²¡æä¸çº§äºï¼æ­¤æ¶åºè¯¥æ¸ç©ºæ¸¸æ ï¼å°æ¶éå°çè·¯å¾æ¾å°ç»æéä¸­
    if (previousValue && previousValue.length > 0) {
      previousValue.pop();
    }
  }
  private isAllowEmpty(value: string | boolean, paths: string[]) {
    if (value === undefined || value === true || value === '') {
      return true;
    }
    // å¼åèå®ä¹äºä¸è½ä¸ºç©ºçè§å
    const frameContexts = this.getFrameContextByBindingPath(paths);
    let caller = this.frameContext.frameComponent;
    if (!frameContexts || frameContexts.length < 1) {
      // å®ä¹äºè§åä½å¯¹åºçFrameæ²¡ææ¸²æ
      console.warn(`ç»å®è·¯å¾ ${paths.join('/')} å®ä¹äºä¸è½ä¸ºç©ºçè§åï¼ä½æ¾ä¸å°è¯¥ç»å®è·¯å¾å¯¹åºçç»ä»¶ãè¯·ç¡®ä¿ç»ä»¶æ¾éä¸å¿å¡«ä¸è´ã`);
    } else {
      caller = frameContexts.pop().frameComponent;
    }
    if (typeof value === 'boolean') {
      return value;
    } else if (typeof value === 'string') {
      value = value.trim().startsWith('return') ? value : `return ${value}`;
      const factory = new Function(`
        var viewModel = this.viewModel;
        var bindingData = this.bindingData;
        var context = this.context;
        ${value}
      `);
      return factory.apply(caller);
    } else {
      console.warn(`æ æçå¿å¡«è§åã`);
    }
  }
  collectValidationErrors(rootViewModel: ViewModel, errors: ValidationError[], namespace: string, filter: boolean = true) {
    if (filter) {
      rootViewModel.verifyInformations = rootViewModel.verifyInformations.filter(item => item.namespace !== namespace);
    }
    errors.forEach((validationError: ValidationError) => {
      if (validationError.children && validationError.children.length) {
        this.collectValidationErrors(rootViewModel, validationError.children, namespace, false);
      }
      let id = '';
      const findId = (target: any) => {
        if (target && target.data && target.data.id) {
          id = target.data.id;
          return;
        } else if (target[PARENT_CLASS]) {
          findId(target[PARENT_CLASS]);
        }
      };
      findId(validationError.target);
      if (validationError.constraints) {
        const validationResultTypes = Object.keys(validationError.constraints);
        if (validationResultTypes.length) {
          const offset = rootViewModel.verifyInformations.filter((item) => item.namespace === namespace).length;
          let index = rootViewModel.verifyInformations.findIndex((item) => item.namespace === namespace);
          index = index === -1 ? 0 : index + offset;
          rootViewModel.verifyInformations.splice(index, 0, {
            id: id,
            namespace,
            targetField: validationError.field,
            index: validationError.index,
            title: validationError.propertyName,
            msg: validationError.constraints[validationResultTypes[0]],
            frameContext: validationError.frameContext,
            fullPath: validationError.fullPath,
            type: ['required', 'require'].includes(validationResultTypes[0]) ? 'empty' : 'error'
          });
        }
      }
    });
  }
  /**
   * éç½®æ ¡éªä¿¡æ¯ï¼ä»å½åè¡¨åï¼
   */
  public resetValidation(): Observable<any> {
    const isDialog = this.isInDialog();
    let rootViewModel = this.frameContext.root.viewModel;
    if (isDialog) {
      rootViewModel = this.frameContext.getVirtualRootFrameContext().viewModel;
    }
    let verifyInformations = rootViewModel.verifyInformations;
    if (verifyInformations.length) {
      const namespace = this.frameContext.namespace;
      if (namespace !== null) {
        verifyInformations = rootViewModel.verifyInformations.filter(item => item.namespace !== namespace);
      }
      rootViewModel.verifyInformations = verifyInformations;
      //rootViewModel.verifyInformations.splice(0, rootViewModel.verifyInformations.length);
    }
    if (rootViewModel && rootViewModel.verifycationChanged) {
      rootViewModel.verifycationChanged.next(verifyInformations);
    }
    return of(null);
  }
  /**
   * æ¯å¦å¨å¼¹çªåé¨
   */
  private isInDialog() {
    return this.frameContext && this.frameContext.getVirtualRootFrameContext() && this.frameContext.getVirtualRootFrameContext().frameComponent && this.frameContext.getVirtualRootFrameContext().frameComponent['isDialogRootComponent'] || false;
  }
  /**
   * æ¥æç¬èªçæ ¡éªæç¤ºæå¡
   */
  private hasOwnVerifyDetailService() {
    return this.frameContext.injector.get<VerifyDetailService>(VerifyDetailService, null) !== this.frameContext.root.appContext.injector.get<VerifyDetailService>(VerifyDetailService, null);;
  }
  /**
   * éè¿bindingPathè·åææå¹éçframeContext
   * @param bindingPath
   * @returns
   */
  private getFrameContextByBindingPath(bindingPaths: string[]): FrameContext[] {
    const bindingPath = bindingPaths.filter(p => p).join('/');
    return this.frameContext.appContext.frameContextManager.getFrameContexts().filter(frameContext => frameContext.viewModel.bindingPath.split('/').filter(p => p).join('/') === bindingPath);
  }
  private get verifyDetailService() {
    return this.frameContext.injector.get<VerifyDetailService>(VerifyDetailService, null, InjectFlags.Self);
  }
  private handleErrorClickEvent() {
    if (this.verifyDetailService && this.verifyDetailService.verifyContainer && this.verifyDetailService.verifyContainer.instance) {
      this.verifyDetailService.verifyContainer.instance.validatorClick.subscribe((item: any) => {
        this.onErrorItemClick(item);
      });
    }
  }
  private onErrorItemClick(item: { frameContext: FrameContext, id: string, targetField: string, fullPath: string; } = { frameContext: null, id: null, targetField: null, fullPath: null }) {
    const { frameContext, id, targetField, fullPath } = item;
    const isGridComponent = frameContext && frameContext.frameComponent.isGridComponent || false;
    if (!isGridComponent) {
      if (!targetField) { }
      const elementRef = frameContext.injector.get(ElementRef, null, InjectFlags.Self) || frameContext.injector.get(ElementRef, null);
      VerifyService.focusElement(targetField, elementRef);
      this.verifyDetailService.verifyContainer.instance.showList = false;
    } else {
      // find grid component
      const grid: DatagridComponent = frameContext.componentRefManager.getComponentByType(DatagridComponent);
      if (grid && targetField && id) {
        grid.editCell(id, targetField);
        this.verifyDetailService.verifyContainer.instance.showList = false;
      }
    }
  }
}

export { ValidationService };
